export default function SelectField({
  field,
  value = "",
  onChange,
  error,
  disabled,
}) {
  return (
    <div className="dynamic-field-control">
      <label className="dynamic-field-control__label" htmlFor={field.key}>
        {field.label}
        {field.required && (
          <span className="dynamic-field-control__required">*</span>
        )}
      </label>

      <select
        id={field.key}
        value={value || ""}
        disabled={disabled}
        className={`dynamic-field-control__select ${
          error ? "dynamic-field-control__select--error" : ""
        }`}
        onChange={(e) => onChange(field.key, e.target.value)}
      >
        <option value="">Selecteer...</option>

        {(field.options || []).map((option) => (
          <option key={option.value || option} value={option.value || option}>
            {option.label || option}
          </option>
        ))}
      </select>

      {error && <span className="dynamic-field-control__error">{error}</span>}
    </div>
  );
}
